import { get } from "lodash";
import moment from "moment";
import { REHYDRATE } from "redux-persist";
import AuthenticationActionTypes from "services/authentication/types";
import ContractActionTypes from "services/contract/types";
import AlertEventsTypes from "./alertEvents/types";
import AlertPoliciesTypes from "./alertPolicies/types";

const initialState = {
  alertEvents: {
    data: {},
    initialized: false,
    filters: {
      from: moment().startOf("month"),
      to: moment().endOf("day"),
      rules: undefined,
      alert_policies: undefined,
      output_types: ["BO_TOAST", "BO"],
    },
    pagination: {
      page: 1,
      limit: 100,
    },
  },
  alertPolicies: {
    data: [],
    initialized: false,
  },
};

const AlertFactoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE:
      return {
        ...initialState,
        alertEvents: {
          ...get(initialState, "alertEvents"),
        },
        alertPolicies: {
          ...get(initialState, "alertPolicies"),
        },
      };
    case ContractActionTypes.SWITCH_CONTRACT:
    case AuthenticationActionTypes.LOG_OUT:
      return initialState;
    case AlertEventsTypes.SET_ALERT_EVENTS_INITIALIZED:
      return {
        ...state,
        alertEvents: { ...state.alertEvents, initialized: action.initialized },
      };
    case AlertEventsTypes.SET_ALERT_EVENTS:
      return {
        ...state,
        alertEvents: {
          ...state.alertEvents,
          data: action.data,
        },
      };
    case AlertEventsTypes.SET_ALERT_EVENTS_FILTERS:
      return {
        ...state,
        alertEvents: {
          ...state.alertEvents,
          filters: {
            ...state.alertEvents.filters,
            [action.key]: action.value,
          },
        },
      };
    case AlertEventsTypes.SET_ALERT_EVENTS_PAGE:
      return {
        ...state,
        alertEvents: {
          ...state.alertEvents,
          pagination: { ...state.alertEvents.pagination, page: action.page },
        },
      };
    case AlertEventsTypes.SET_ALERT_EVENTS_LIMIT:
      return {
        ...state,
        alertEvents: {
          ...state.alertEvents,
          pagination: { ...state.alertEvents.pagination, limit: action.limit },
        },
      };
    case AlertPoliciesTypes.SET_ALERT_POLICIES_INITIALIZED:
      return {
        ...state,
        alertPolicies: {
          ...state.alertPolicies,
          initialized: action.initialized,
        },
      };
    case AlertPoliciesTypes.SET_ALERT_POLICIES:
      return {
        ...state,
        alertPolicies: { data: action.data, initialized: true },
      };
    default:
      return state;
  }
};

export default AlertFactoryReducer;
